import { rem } from 'polished'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styled from 'styled-components'
import Icon, { ICON_SIZE } from 'components/Icon'
import { Input } from 'components/Input'
import { Box } from 'components/Layout'
import { COLOR } from 'Theme'

const VISIBILITY_ICON_MARGIN = {
  TOP: rem(28),
  RIGHT: rem(12),
}

const INPUT_TYPE = {
  PASSWORD: 'password',
  STRING: 'string',
}

const IconWrapper = styled(Box)`
  cursor: pointer;
`
const PasswordInput = ({ label, hasVisibilityButton, ...props }) => {
  const [passwordInputType, setPasswordInputType] = useState(
    INPUT_TYPE.PASSWORD
  )
  const handleToggleCurrentPassword = () =>
    passwordInputType === INPUT_TYPE.PASSWORD
      ? setPasswordInputType(INPUT_TYPE.STRING)
      : setPasswordInputType(INPUT_TYPE.PASSWORD)
  return (
    <Box display="inline-flex" position="relative" width="100%">
      <Input {...props} type={passwordInputType} label={label} />
      {hasVisibilityButton && (
        <IconWrapper
          position="absolute"
          mt={VISIBILITY_ICON_MARGIN.TOP}
          mr={VISIBILITY_ICON_MARGIN.RIGHT}
          right={0}
          onClick={handleToggleCurrentPassword}
        >
          {passwordInputType === INPUT_TYPE.PASSWORD ? (
            <Icon.Visible size={ICON_SIZE.PX_20} color={COLOR.GRAYSCALE_3} />
          ) : (
            <Icon.Hidden size={ICON_SIZE.PX_20} color={COLOR.GRAYSCALE_3} />
          )}
        </IconWrapper>
      )}
    </Box>
  )
}

PasswordInput.defaultProps = {
  label: 'Password',
  hasVisibilityButton: false,
}

PasswordInput.propTypes = {
  label: PropTypes.string,
  hasVisibilityButton: PropTypes.bool,
}

export default PasswordInput
